import lamanteRegistry from './registry/lamante';
import { getRuntimePreferredSiteId } from './runtimeShellConfig';
import { SiteDefinition } from './SiteDefinition';

const registry: Record<string, SiteDefinition> = lamanteRegistry;

export const SITE_FALLBACK_ID = 'default';

export const siteDefinitions: SiteDefinition[] = Object.values(registry);

export const getSiteById = (siteId?: string): SiteDefinition | undefined => {
    if (!siteId) {
        return undefined;
    }

    return registry[siteId];
};

const matchSiteByHostname = (hostname?: string): SiteDefinition | undefined => {
    if (!hostname) {
        return undefined;
    }

    const normalized = hostname.toLowerCase();

    return siteDefinitions.find(site =>
        site.hostnames?.some(hostnameEntry => hostnameEntry.toLowerCase() === normalized)
    );
};

export const getActiveSiteDefinition = (hostname?: string, preferredSiteId?: string): SiteDefinition => {
    if (preferredSiteId) {
        const match = getSiteById(preferredSiteId);
        if (match) {
            return match;
        }
    }

    const runtimeSiteId = getRuntimePreferredSiteId();
    if (runtimeSiteId) {
        const match = getSiteById(runtimeSiteId);
        if (match) {
            return match;
        }
    }

    const envSiteId = process.env.REACT_APP_SITE_ID;
    if (envSiteId) {
        const match = getSiteById(envSiteId);
        if (match) {
            return match;
        }
    }

    const hostnameMatch = matchSiteByHostname(hostname);
    if (hostnameMatch) {
        return hostnameMatch;
    }

    return registry[SITE_FALLBACK_ID];
};
